export const retrieveEmployeesDetails = async (
  token,
  userId,
  searchText,
  limit,
  index
) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    search_text: searchText,
    limit: limit,
    index: index,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/retrive-employee`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve user: " + error.message);
  }
};

export const DeleteEmployeesDetails = async (token, userId, id) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    id: id,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/delete-employee`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};

export const AutocompleteEmployeesDetails = async (
  token,
  userId,
  searchText
) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    search_text: searchText,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/autocomplete-employee`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};
export const createEmployeesDetails = async (userToken, UseradminData) => {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${userToken}`);

    const formData = new FormData();

    // Append text fields to FormData
    formData.append("name", UseradminData.fullname);
    formData.append("email", UseradminData.email);
    formData.append("designation", UseradminData.designation);
    formData.append("blood_group", UseradminData.bloodgroup);
    formData.append("phone", UseradminData.phone);
    formData.append("salary", UseradminData.salary);
    formData.append("joining_date", UseradminData.joiningdate);
    formData.append("address", UseradminData.address);
    formData.append("image", UseradminData.selectedFile);
    formData.append("card_number", UseradminData.batchnumber);
    formData.append("morning_slot", UseradminData.morningSlot); // Add morning slot
    formData.append("evening_slot", UseradminData.eveningSlot); // Add evening slot
    formData.append("excuse_time", UseradminData.excuseTime); // Add excuse time
    
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    const response = await fetch(
      `${window.constants.api_url}/add-employee`,
      requestOptions
    );
    const result = await response.json(); // Parse response as JSON
    return result;
  } catch (error) {
    throw new Error("Failed to create package: " + error.message);
  }
};

export const UpdateEmployees = async (id, userToken, editedData) => {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${userToken}`);

    const formData = new FormData();
    formData.append("id", id);
    formData.append("name", editedData.fullname);
    formData.append("email", editedData.email);
    formData.append("designation", editedData.designation);
    formData.append("blood_group", editedData.bloodgroup);
    formData.append("phone", editedData.phone);
    formData.append("salary", editedData.salary);
    formData.append("joining_date", editedData.joiningdate);
    formData.append("address", editedData.address);
    if (editedData.card_number) formData.append("card_number", editedData.card_number);
    if (editedData.selectedFile) formData.append("image", editedData.selectedFile);
    if (editedData.morningSlot !== undefined && editedData.morningSlot !== null) formData.append("morning_slot", editedData.morningSlot);
    if (editedData.eveningSlot !== undefined && editedData.eveningSlot !== null) formData.append("evening_slot", editedData.eveningSlot);
    if (editedData.excuseTime !== undefined && editedData.excuseTime !== null) formData.append("excuse_time", editedData.excuseTime);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    const response = await fetch(
      `${window.constants.api_url}/update-employee`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to update user: " + error.message);
  }
};
